import { ColumnMeta } from '../../../../../types';

export function getColumnWidth(column: ColumnMeta): { width: number; minWidth?: number } {
  const size = column?.meta?.size;

  switch (size) {
    case 'XS':
      return { width: 120, minWidth: 120 };
    case 'S':
      return { width: 160, minWidth: 160 };
    case 'M':
      return { width: 200, minWidth: 200 };
    case 'L':
      return { width: 340, minWidth: 340 };
    default:
      return { width: 200, minWidth: 200 };
  }
}
